import React, { useState } from "react";
import {Columns, Column, Box, Flex, Text, css, DNA} from "@dna/react";
import { AppBackgroundColor, AppBorderColor, AppBorderSize } from '../style/emed.style';
import { Button, ButtonMode } from "@communicare/medications/Components/Button"
import {CloseIcon, FilterIcon, TickIcon} from "@communicare/medications/Components/Icons"

const LeftPane = (props: {
    togglePaneVisibility: () => void;
    children:JSX.Element;
}) => {
    return <Box>
        <Flex
            css={{
                gap: 0,
                justifyContent: "space-between",
                // alignItems: "start"
            }}

        >

            <Columns
                css={{
                    gap: 0,
                    alignItems: "start",
                    backgroundColor: AppBackgroundColor,
                    borderTopColor: AppBorderColor,
                    borderTopWidth: AppBorderSize,
                    borderBottomColor: AppBorderColor,
                    borderBottomWidth: AppBorderSize,
                    width: "100%"
                }}

            >
                <Column width="4/5" css={{
                    backgroundColor: AppBackgroundColor,
                    paddingStart: "17px",
                    justifySelf: "center",
                    alignSelf: "center"
                }}>
                    <Text level="medium" as="strong">Filter</Text>
                </Column>
                
                <Column css={{
                    backgroundColor: AppBackgroundColor,
                    justifySelf: "center",
                    alignSelf: "center"
                }}>
                    <Flex UNSAFE_className={css({
                        display: "flex",
                        flexDirection: "row-reverse",
                        alignItems:"center"
                    })}>
                        <div className={css({
                            borderLeftColor: DNA.tokens.color.gray["300"],
                            borderLeftWidth: DNA.tokens.dimension.borderSize["25"],
                            borderLeftStyle:"solid",
                            borderRightColor: DNA.tokens.color.gray["300"],
                            borderRightWidth: DNA.tokens.dimension.borderSize["25"],
                            borderRightStyle:"solid"
                        })}>
                            <Button
                                testId="close-filter"
                                onClick={props.togglePaneVisibility}
                                mode={ButtonMode.text}
                                iconOnly
                                noShadowOnHover
                                subtleShadeOnHover
                            >
                                <CloseIcon color='#aaa' />
                            </Button>
                        </div>    
                    </Flex>
                    
                </Column>
                
            </Columns>

            {props.children}


        </Flex>
    </Box >
};

export const TwoPanelContainer=(props:{
    filters:JSX.Element,
    listHeaderTitle:JSX.Element,
    listHeaderActions?:JSX.Element,
    body:JSX.Element,
    defaultState?:'Open'|'Closed'
})=>{

    const [filterOpen, setFilterOpen] = useState(props.defaultState==="Open");
    
    return (
        <Columns
            css={{
                gap: 0,
                paddingTop: "size-200",
                flexBasis:"auto",
                flexGrow:1,
                flexShrink:1
            }}
        >

            <Column width="1/4" css={{
                backgroundColor: AppBackgroundColor
            }}
                UNSAFE_style={{
                    display: filterOpen ? "" : "none"
                }}
            >
                <LeftPane
                    togglePaneVisibility={() => setFilterOpen(!filterOpen)}
                >
                    {props.filters}
                </LeftPane>
            </Column>

            <Column>
                <Flex
                    css={{
                        gap: 0
                    }}
                >

                    <Columns
                        css={{
                            gap: 0,
                            alignItems: "start",
                            backgroundColor: AppBackgroundColor,
                            borderTopColor: AppBorderColor,
                            borderTopWidth: AppBorderSize,
                            borderBottomColor: AppBorderColor,
                            borderBottomWidth: AppBorderSize,
                            width: "100%"
                        }}

                    >
                        <Column width="4/5" css={{
                            backgroundColor: AppBackgroundColor,
                            paddingStart: "17px",
                            justifySelf: "center",
                            alignSelf: "center"
                        }}>

                            {props.listHeaderTitle}

                        </Column>
                        <Column>
                            <Flex css={{
                                gap:"small"
                            }} UNSAFE_className={css({
                                display: "flex",
                                flexDirection: "row-reverse",
                                alignItems:"center"
                            })}>
                                <Box css={{
                                    borderStartColor: AppBorderColor,
                                    borderStartWidth: AppBorderSize
                                }}>
                                    <Button
                                        testId='button-close'
                                        onClick={() => setFilterOpen(!filterOpen)}
                                        mode={ButtonMode.text}

                                        iconOnly
                                        noShadowOnHover
                                        subtleShadeOnHover
                                    >
                                        <FilterIcon color="#008381" />
                                    </Button>
                                </Box>

                                {props.listHeaderActions}

                            </Flex>



                        </Column>
                    </Columns>

                    {props.body}

                </Flex>
            </Column>
        </Columns>
    );
}